import { TOKEN_KEY } from '../../utils/config'

const state = {
  token: localStorage.getItem(TOKEN_KEY) || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem(TOKEN_KEY, token)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
    localStorage.setItem('userInfo', JSON.stringify(info))
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
